import { Directive, ElementRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { app_themes } from './themes.const';
import { ThemeService } from './theme.service';
import { Subscription } from 'rxjs';
import * as store from 'store';
import { AuthService } from '../modules/auth/auth.service';

@Directive({
  selector: '[appTheme]'
})
export class ThemeDirective implements OnInit, OnDestroy {
  public static THEME = 'THEME';
  public static LOGIN_LOGO_PATH = 'login_logo_path';
  public static LOGO_PATH = 'logo_path';
  public static LOGO_ALT = 'logo_alt';
  public static FAVICON_PATH = 'favicon_path';
  public static APP_TITLE = 'app_title';
  public static COPYRIGHT = 'copyright';

  public static APP_FAVICON_ID = 'appFavicon';
  public static APP_TITLE_ID = 'appTitle';

  private isInitialized = false;
  private themeServiceSubscription: Subscription;
  constructor(
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: any,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.themeService.getActiveTheme().subscribe(themeName => {
      if (!themeName) return;

      if (!this.isInitialized) {
        const themeInStore = store.get(ThemeDirective.THEME);
        if (themeInStore) {
          themeName = themeInStore;
        }
        this.isInitialized = true;
      }

      this.updateTheme(themeName);
      store.set(ThemeDirective.THEME, themeName);
    });
  }

  updateTheme(themeName: string) {
    if (!themeName) return;
    try {
      const theme = app_themes[themeName];
      if (!theme) return;

      //change styles
      const element = this.elementRef.nativeElement;
      for (const key in theme) {
        element.style.setProperty(key, theme[key]);
        this.document.body.style.setProperty(key, theme[key]);
      }

      //change favicon
      const appFavicon = this.document.getElementById(ThemeDirective.APP_FAVICON_ID);
      if (appFavicon) {
        appFavicon.setAttribute('href', theme[ThemeDirective.FAVICON_PATH]);
      }

      //change title
      const appTitle = this.document.getElementById(ThemeDirective.APP_TITLE_ID);
      if (appTitle) {
        appTitle.innerHTML = theme[ThemeDirective.APP_TITLE];
      }
    } catch (err) {
      console.log(err);
    }
  }

  ngOnDestroy() {
    if (this.themeServiceSubscription) this.themeServiceSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/theme.directive.ts